import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";

export default function NotFound() {
  const nav = useNavigate();
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", px: 2 }}>
      <Stack alignItems="center" spacing={2}>
        <SentimentDissatisfiedOutlinedIcon sx={{ fontSize: 64, color: "text.secondary" }} />
        <Typography variant="h3" fontWeight={800}>
          404
        </Typography>
        <Typography color="text.secondary">Page not found.</Typography>
        <Button variant="contained" onClick={() => nav("/")}>
          Go Home
        </Button>
      </Stack>
    </Box>
  );
}
